// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import md5 from 'md5'
import 'babel-polyfill'
import 'normalize.css/normalize.css' // 保护有价值的默认值，修复浏览器的bug，优化css可用性
import router from './router'
import Element from 'element-ui'
import i18n from './lang' // 国际化
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/common.css'
Vue.config.productionTip = false
Vue.use(md5)
Vue.use(Element)
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js